<app-side-menu>
  <div class="staff-form-container">
    <!-- Loading overlay quando carregando usuário -->
    <app-loading
      [show]="loadingUser"
      [message]="'Carregando dados do usuário...'"
      [size]="'medium'"
      [overlay]="true">
    </app-loading>

    <div class="form-header">
      <h1>
        <i class="fas" [ngClass]="isEditMode ? 'fa-user-edit' : 'fa-user-plus'"></i> 
        {{ isEditMode ? 'Editar Usuário' : 'Cadastro de Usuário' }}
      </h1>
      <p>{{ isEditMode ? 'Edite as informações da conta de acesso' : 'Crie uma nova conta de acesso no sistema' }}</p>
    </div>

    <div class="tabs-navigation">
      <div class="tab-item" [class.active]="activeTab === 'access'" (click)="selectTab('access')">
        <i class="fas fa-key"></i>
        <span class="tab-label">Dados de Acesso</span>
      </div>
      <div class="tab-item" [class.active]="activeTab === 'config'" (click)="selectTab('config')">
        <i class="fas fa-cog"></i>
        <span class="tab-label">Configurações</span>
      </div>
      <div class="tab-item" [class.active]="activeTab === 'link'" (click)="selectTab('link')">
        <i class="fas fa-link"></i>
        <span class="tab-label">Vínculo</span>
      </div>
      <div class="tab-item" *ngIf="isEditMode" [class.active]="activeTab === 'permissions'" (click)="selectTab('permissions')">
        <i class="fas fa-shield-alt"></i>
        <span class="tab-label">Permissões</span>
      </div>
    </div>

    <div class="tab-content">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <!-- Dados de Acesso -->
        <div class="tab-panel" *ngIf="activeTab === 'access'">
          <div class="detail-section">
            <h3><i class="fas fa-key"></i> Dados de Acesso</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label for="name">Nome Completo *</label>
                <input type="text" id="name" formControlName="name" placeholder="Digite o nome completo" [class.is-invalid]="submitted && f['name'].errors">
                <div class="invalid-feedback" *ngIf="submitted && f['name'].errors">
                  <span *ngIf="f['name'].errors['required']">Nome é obrigatório</span>
                  <span *ngIf="f['name'].errors['minlength']">Nome deve ter pelo menos 3 caracteres</span>
                  <span *ngIf="f['name'].errors['maxlength']">Nome deve ter no máximo 100 caracteres</span>
                </div>
              </div>
              <div class="detail-item">
                <label for="email">E-mail *</label>
                <input type="email" id="email" formControlName="email" placeholder="exemplo@empresa.com" [class.is-invalid]="submitted && f['email'].errors">
                <div class="invalid-feedback" *ngIf="(submitted || f['email'].touched) && f['email'].errors">
                  <span *ngIf="f['email'].errors['required']">E-mail é obrigatório</span>
                  <span *ngIf="f['email'].errors['email']">E-mail inválido</span>
                  <span *ngIf="f['email'].errors['emailExists']">Este e-mail já está em uso</span>
                </div>
                <div class="text-muted small" *ngIf="f['email'].pending">
                  <i class="fas fa-spinner fa-spin me-1"></i>
                  Verificando disponibilidade...
                </div>
              </div>
            </div>
            
            <div class="checkbox-wrapper" style="margin: 20px 0;" *ngIf="!isEditMode">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="useSenhaPadrao" [(ngModel)]="useSenhaPadrao" (ngModelChange)="onSenhaPadraoChange($event)" [ngModelOptions]="{standalone: true}">
                <label class="form-check-label" for="useSenhaPadrao">
                  <span class="me-2">Senha Padrão</span>
                  <i class="fas fa-info-circle text-info" title="Será enviado um Email para o Usuário redefinir sua Senha"></i>
                </label>
              </div>
            </div>

            <div class="alert alert-info" *ngIf="isEditMode">
              <i class="fas fa-info-circle me-2"></i>
              <strong>Nota:</strong> A senha não pode ser alterada aqui. Para redefinir a senha, use a opção de reset de senha.
            </div>

            <div class="detail-grid" *ngIf="!useSenhaPadrao">
              <div class="detail-item">
                <label for="password">Senha <span *ngIf="!useSenhaPadrao">*</span></label>
                <input type="password" id="password" formControlName="password" [class.is-invalid]="submitted && f['password'].errors && !useSenhaPadrao" [class.input-disabled]="useSenhaPadrao" [disabled]="useSenhaPadrao" placeholder="Digite a senha">
                <div class="invalid-feedback" *ngIf="submitted && f['password'].errors && !useSenhaPadrao">
                  <span *ngIf="f['password'].errors['required']">Senha é obrigatória</span>
                  <span *ngIf="f['password'].errors['minlength']">Senha deve ter pelo menos 6 caracteres</span>
                </div>
              </div>
              <div class="detail-item">
                <label for="confirmPassword">Confirmar Senha <span *ngIf="!useSenhaPadrao">*</span></label>
                <input type="password" id="confirmPassword" formControlName="confirmPassword" [class.is-invalid]="submitted && f['confirmPassword'].errors && !useSenhaPadrao" [class.input-disabled]="useSenhaPadrao" [disabled]="useSenhaPadrao" placeholder="Confirme a senha">
                <div class="invalid-feedback" *ngIf="submitted && f['confirmPassword'].errors && !useSenhaPadrao">
                  <span *ngIf="f['confirmPassword'].errors['required']">Confirmação de senha é obrigatória</span>
                </div>
              </div>
            </div>
            <div class="alert alert-danger mt-3" *ngIf="submitted && userForm.errors?.['passwordMismatch'] && !useSenhaPadrao">
              <i class="fas fa-exclamation-triangle me-2"></i>
              As senhas não coincidem.
            </div>
          </div>
        </div>

        <!-- Configurações do Usuário -->
        <div class="tab-panel" *ngIf="activeTab === 'config'">
          <div class="detail-section">
            <h3><i class="fas fa-cog"></i> Configurações</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label for="profileId">Perfil de Acesso *</label>
                <div *ngIf="loadingProfiles" class="text-muted small mb-2">
                  <i class="fas fa-spinner fa-spin me-1"></i>
                  Carregando perfis...
                </div>
                <select id="profileId" formControlName="profileId" [class.is-invalid]="submitted && f['profileId'].errors" [disabled]="loadingProfiles">
                  <option value="" disabled>{{ loadingProfiles ? 'Carregando...' : 'Selecione um perfil' }}</option>
                  <option *ngFor="let perfil of perfis" [value]="perfil.value">{{ perfil.label }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="submitted && f['profileId'].errors">
                  <span *ngIf="f['profileId'].errors['required']">Perfil é obrigatório</span>
                </div>
              </div>
              <div class="detail-item">
                <label for="active">Status *</label>
                <input type="text" id="active" [value]="getStatusLabel()" disabled readonly>
              </div>
            </div>

            <!-- Toggle Vendedor com visual semelhante ao "Senha Padrão" -->
            <div class="checkbox-wrapper" style="margin-top: 20px;">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isSeller"
                  formControlName="isSeller">
                <label class="form-check-label" for="isSeller">
                  <span class="me-2">Vendedor</span>
                  <i class="fas fa-info-circle text-info" title="Marque se este usuário também atua como vendedor"></i>
                </label>
              </div>
              <small class="form-text text-muted">
                {{ userForm.get('isSeller')?.value ? 'Este usuário será tratado como vendedor.' : 'Deixe desmarcado se o usuário não for vendedor.' }}
              </small>
            </div>
          </div>
        </div>

        <!-- Vínculo -->
        <div class="tab-panel" *ngIf="activeTab === 'link'">
          <div class="detail-section">
            <h3><i class="fas fa-link"></i> Vincular a Funcionário/Cliente</h3>
            <div class="detail-grid">
              <div class="detail-item full-width">
                <div *ngIf="selectedStaff" class="selected-user-card">
                  <div class="user-info">
                    <h6>{{ selectedStaff.FullName }}</h6>
                    <p class="text-muted">{{ selectedStaff.CPF }}</p>
                    <p class="small">
                      <span class="badge bg-primary me-2">{{ getTipoVinculoLabel(selectedStaff) }}</span>
                      <span *ngIf="selectedStaff.Position">{{ selectedStaff.Position }}</span>
                      <span *ngIf="selectedStaff.Department"> - {{ selectedStaff.Department }}</span>
                    </p>
                  </div>
                  <div class="user-actions">
                    <button type="button" class="btn btn-sm btn-outline-danger remove-user-btn" (click)="limparStaffSelecionado()" title="Remover seleção">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div *ngIf="!selectedStaff" class="text-center">
                  <app-button text="Buscar e Selecionar Funcionário/Cliente" color="var(--primary-color)" (buttonClick)="abrirBuscaUsuario()" className="btn-outline-primary w-100">
                    <i class="fas fa-search me-2"></i>
                  </app-button>
                  <small class="form-text text-muted">Clique para buscar e selecionar o funcionário/cliente que será vinculado a este usuário</small>
                </div>
              </div>
            </div>

            <!-- Busca e Tabela de Staff (app-table) -->
            <div class="staff-table mt-3" *ngIf="showStaffTable">
              <app-loading
                [show]="loadingStaff"
                [message]="'Carregando funcionários...'"
                [size]="'small'"
                [overlay]="false">
              </app-loading>

              <app-table
                *ngIf="!loadingStaff"
                [searchRight]="true"
                [title]="'Funcionários'"
                [data]="filteredStaff"
                [columns]="columns"
                [showSearch]="true"
                [searchPlaceholder]="'Pesquisar funcionários...'"
                [clickable]="true"
                [disablePagination]="false"
                [totalItemsFromBackend]="totalCount"
                (searchChange)="onSearchChange($event)"
                (rowClick)="selecionarStaff($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)">
              </app-table>
            </div>
          </div>
        </div>

        <!-- Permissões do Usuário -->
        <div class="tab-panel" *ngIf="activeTab === 'permissions'">
          <div class="detail-section">
            <h3><i class="fas fa-shield-alt"></i> Permissões Individuais</h3>
            <p class="text-muted mb-3">
              Defina permissões específicas para este usuário. Elas têm prioridade sobre as permissões do perfil.
            </p>

            <app-loading
              [show]="loadingPermissions"
              [message]="'Carregando permissões...'"
              [size]="'medium'"
              [overlay]="false">
            </app-loading>

            <div *ngIf="!loadingPermissions">
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Buscar permissão..."
                  [(ngModel)]="permissionSearchTerm"
                  [ngModelOptions]="{standalone: true}">
              </div>

              <div *ngFor="let permission of getFilteredPermissions()" class="permission-row d-flex align-items-center justify-content-between py-2 px-3 mb-1 border rounded">
                <div>
                  <span class="permission-name fw-semibold">{{ permission.name }}</span>
                  <small class="text-muted ms-2" *ngIf="permission.description">— {{ permission.description }}</small>
                </div>
                <div class="permission-actions d-flex gap-2">
                  <button
                    type="button"
                    class="btn btn-sm"
                    [class.btn-success]="permissionOverrideMap[permission.id] === 'Allow'"
                    [class.btn-outline-success]="permissionOverrideMap[permission.id] !== 'Allow'"
                    (click)="setPermissionOverride(permission.id, permissionOverrideMap[permission.id] === 'Allow' ? null : 'Allow')"
                    title="Permitir">
                    <i class="fas fa-check me-1"></i>Permitir
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm"
                    [class.btn-danger]="permissionOverrideMap[permission.id] === 'Deny'"
                    [class.btn-outline-danger]="permissionOverrideMap[permission.id] !== 'Deny'"
                    (click)="setPermissionOverride(permission.id, permissionOverrideMap[permission.id] === 'Deny' ? null : 'Deny')"
                    title="Negar">
                    <i class="fas fa-ban me-1"></i>Negar
                  </button>
                </div>
              </div>

              <div *ngIf="getFilteredPermissions().length === 0" class="text-center text-muted py-4">
                <i class="fas fa-info-circle me-2"></i>Nenhuma permissão encontrada.
              </div>

              <div class="d-flex justify-content-end mt-3">
                <app-button
                  [text]="savingPermissions ? 'Salvando...' : 'Salvar Permissões'"
                  color="var(--primary-color)"
                  [disabled]="savingPermissions"
                  className="btn-primary"
                  (buttonClick)="savePermissions()">
                  <i class="fas fa-save me-2" *ngIf="!savingPermissions"></i>
                  <i class="fas fa-spinner fa-spin me-2" *ngIf="savingPermissions"></i>
                </app-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Botões de Navegação -->
        <div class="navigation-buttons" *ngIf="activeTab !== 'permissions'">
          <app-button text="Limpar" color="#495057" (buttonClick)="limparFormulario()" className="btn-outline-secondary">
            <i class="fas fa-eraser me-2"></i>
          </app-button>
          <app-button text="Cancelar" color="var(--danger-color)" (buttonClick)="voltar()" className="btn-outline-danger me-2">
            <i class="fas fa-times me-2"></i>
          </app-button>
          <app-button text="{{ isSubmitting ? 'Salvando...' : (isEditMode ? 'Salvar Alterações' : 'Salvar Usuário') }}" color="var(--primary-color)" type="submit" [disabled]="isSubmitting" className="btn-primary">
            <i class="fas fa-save me-2" *ngIf="!isSubmitting"></i>
            <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
          </app-button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>

<!-- Modal de Confirmação -->
<app-modal 
  [isOpen]="showConfirmModal"
  [title]="isEditMode ? 'Confirmar Edição de Usuário' : 'Confirmar Cadastro de Usuário'"
  size="lg"
  (close)="cancelarCadastro()">
  <div class="modal-body confirm-user-modal">
    <!-- Estado padrão -->
    <div *ngIf="!isSubmitting">
      <!-- Cabeçalho visual do passo -->
      <div class="confirm-header">
        <div class="confirm-icon">
          <i class="fas fa-user-check"></i>
        </div>
        <div class="confirm-text">
          <h4>
            {{ isEditMode ? 'Revisar alterações do usuário' : 'Revisar dados do novo usuário' }}
          </h4>
          <p>
            {{ isEditMode ? 'Confira as informações abaixo antes de salvar as alterações.' : 'Confira as informações abaixo antes de concluir o cadastro.' }}
          </p>
        </div>
        <div class="confirm-status-chip">
          <app-button 
            [text]="isEditMode ? 'Confirmar alterações' : 'Confirmar cadastro'"
            color="var(--primary-color)"
            (buttonClick)="confirmarCadastro()"
            className="btn-primary"
            [disabled]="!userForm.valid">
            <i class="fas fa-check me-2"></i>
          </app-button>
        </div>
      </div>

      <!-- Layout em cartões lado a lado -->
      <div class="confirm-grid" *ngIf="userForm.valid">
        <!-- Bloco de dados do usuário -->
        <section class="confirm-card">
          <header class="confirm-card__header">
            <div class="confirm-card__icon">
              <i class="fas fa-user"></i>
            </div>
            <div>
              <h6>Dados do Usuário</h6>
              <span class="muted">Informações principais de acesso</span>
            </div>
          </header>

          <div class="confirm-card__body">
            <div class="field-row">
              <span class="field-label">Nome</span>
              <span class="field-value">{{ userForm.get('name')?.value }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">E-mail</span>
              <span class="field-value">{{ userForm.get('email')?.value }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">Perfil</span>
              <span class="field-value">
                {{ getPerfil(userForm.get('profileId')?.value) }}
              </span>
            </div>
            <div class="field-row">
              <span class="field-label">Senha</span>
              <span class="field-value">
                <span *ngIf="useSenhaPadrao" class="pill pill-info">
                  <i class="fas fa-envelope me-1"></i>
                  Será enviada por e-mail
                </span>
                <span *ngIf="!useSenhaPadrao" class="pill pill-success">
                  <i class="fas fa-key me-1"></i>
                  Definida manualmente
                </span>
              </span>
            </div>
          </div>
        </section>

        <!-- Bloco de vínculo -->
        <section class="confirm-card">
          <header class="confirm-card__header">
            <div class="confirm-card__icon">
              <i class="fas fa-link"></i>
            </div>
            <div>
              <h6>Vínculo</h6>
              <span class="muted">Funcionário/cliente associado ao usuário</span>
            </div>
          </header>

          <div class="confirm-card__body" *ngIf="selectedStaff; else noLink">
            <div class="field-row">
              <span class="field-label">Nome</span>
              <span class="field-value">{{ selectedStaff.FullName }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">CPF</span>
              <span class="field-value">{{ selectedStaff.CPF }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">Tipo</span>
              <span class="field-value">
                <span class="pill pill-primary">{{ getTipoVinculoLabel(selectedStaff) }}</span>
              </span>
            </div>
            <div class="field-row" *ngIf="selectedStaff.Position">
              <span class="field-label">Cargo</span>
              <span class="field-value">{{ selectedStaff.Position }}</span>
            </div>
            <div class="field-row" *ngIf="selectedStaff.Department">
              <span class="field-label">Departamento</span>
              <span class="field-value">{{ selectedStaff.Department }}</span>
            </div>
          </div>

          <ng-template #noLink>
            <div class="no-link-warning">
              <div class="no-link-icon">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="no-link-text">
                <strong>Atenção</strong>
                <p>Este usuário não está vinculado a nenhum funcionário/cliente.</p>
              </div>
            </div>
          </ng-template>
        </section>
      </div>

      <!-- Mensagem quando o formulário ainda não está válido -->
      <div class="invalid-summary" *ngIf="!userForm.valid">
        <div class="invalid-summary__icon">
          <i class="fas fa-info-circle"></i>
        </div>
        <div>
          <h6>Revise os dados antes de confirmar</h6>
          <p class="muted">Existem informações pendentes ou inválidas no formulário.</p>
        </div>
      </div>

      <!-- Botões de confirmação movidos para o cabeçalho do modal -->
    </div>

    <!-- Loading State -->
    <div *ngIf="isSubmitting" class="confirm-loading">
      <div class="confirm-loading__spinner">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>
      <div class="confirm-loading__text">
        <h5>{{ isEditMode ? 'Atualizando usuário...' : 'Criando usuário...' }}</h5>
        <p class="muted">
          {{ isEditMode ? 'Por favor, aguarde enquanto processamos a atualização.' : 'Por favor, aguarde enquanto processamos o cadastro.' }}
        </p>
        <div class="confirm-loading__progress">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<!-- (Modal de busca removido; busca inline com tabela adicionada) -->